import * as ko from 'knockout';
import page from 'page';
import { getAuth, applyActionCode } from 'firebase/auth';

let template = require('raw-loader!../../templates/revert_second_factor.html').default;

class RevertSecondFactorScreen {
  loading = ko.observable(true);
  success = ko.observable<boolean>();
  error = ko.observable<boolean>();

  constructor(params: { oobCode: string; tenantId?: string }) {
    const auth = getAuth();
    auth.tenantId = params.tenantId ?? null;

    applyActionCode(auth, params.oobCode)
      .then(() => {
        this.success(true);
      })
      .catch(() => {
        this.error(true);
      })
      .finally(() => this.loading(false));
  }

  start() {
    page('/');
  }
}

export let revertSecondFactorScreen = {
  name: 'revert-second-factor',
  viewModel: RevertSecondFactorScreen,
  template: template,
};

ko.components.register(revertSecondFactorScreen.name, revertSecondFactorScreen);
